var enUS = {
  product: {
    SOLD_OUT: 'Sold Out',
    FINAL_PRICE: 'Final Price',
    BUY_NOW: 'Buy Now'
  }
};
export default enUS;